import createTransform from '../geometry/transform';

export default function translateToPoint(point, bbox, element) {
    var transofrm = element.transform() || createTransform();
    var matrix = transofrm.matrix();
    matrix.e += point.x - bbox.origin.x;
    matrix.f += point.y - bbox.origin.y;

    transofrm.matrix(matrix);
    element.transform(transofrm);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/alignment/translate-to-point.js
// module id = 227
// module chunks = 0